import { EntityMultiValuedListMoreItem } from '../../Entity'

import BuildingIcon from '../../../icons/building.svg'

function BuildingMultiValuedListMoreItem(props) {
  return <EntityMultiValuedListMoreItem {...props} Icon={BuildingIcon} />
}

export default BuildingMultiValuedListMoreItem
